import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Switch } from '../components/ui/switch';
import { useSettings } from '../hooks/useSettings';
import { Settings as SettingsIcon, ArrowLeft } from 'lucide-react';

const Settings: React.FC = () => {
  const history = useHistory();
  const { settings, updateSettings, isLoading } = useSettings();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-muted-foreground">Loading settings...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background p-4 md:p-8">
      <div className="max-w-4xl mx-auto space-y-6">
        {/* Header */}
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => history.push('/')}
            className="h-10 w-10"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div className="flex items-center gap-2">
            <SettingsIcon className="h-6 w-6" />
            <h1 className="text-3xl font-bold">Settings</h1>
          </div>
        </div>

        {/* Camera Settings */}
        <Card>
          <CardHeader>
            <CardTitle>Input Options</CardTitle>
            <CardDescription>
              Configure how you can input images for processing
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="space-y-0.5">
                <Label htmlFor="camera-enabled" className="text-base">
                  Enable Camera Input
                </Label>
                <p className="text-sm text-muted-foreground">
                  Allow users to capture images using their device camera
                </p>
              </div>
              <Switch
                id="camera-enabled"
                checked={settings.cameraEnabled}
                onCheckedChange={(checked) => updateSettings({ cameraEnabled: checked })}
              />
            </div>
          </CardContent>
        </Card>

        {/* Back Button */}
        <div className="flex justify-end">
          <Button onClick={() => history.push('/')}>
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Settings;

